export const PersonalityColors = ['green', 'blue', 'ruby', 'purple'] as const;
